/**
 * Dicono di Noi testimonials slider
 */
(function () {
  function init(root) {
    if (!root || root.dataset.sgTestimonialsReady === '1') return;
    var track = root.querySelector('[data-sg-testimonials-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sg-testimonials-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-sg-testimonials-dot]'));
    if (!track || slides.length < 2) return;

    root.dataset.sgTestimonialsReady = '1';
    var index = 0;
    var autoplay = root.getAttribute('data-autoplay') !== 'false';
    var interval = parseInt(root.getAttribute('data-interval') || '6000', 10);
    if (isNaN(interval) || interval < 2000) interval = 6000;
    var timer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(next) {
      index = ((next % slides.length) + slides.length) % slides.length;
      track.style.transform = 'translateX(' + -index * 100 + '%)';
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (!autoplay || reduceMotion) return;
      timer = setInterval(function () {
        goTo(index + 1);
      }, interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index') || '0', 10);
        goTo(i);
        start();
      });
    });

    var startX = 0;
    var deltaX = 0;
    track.addEventListener(
      'touchstart',
      function (e) {
        if (!e.touches || !e.touches[0]) return;
        startX = e.touches[0].clientX;
        deltaX = 0;
        stop();
      },
      { passive: true }
    );
    track.addEventListener(
      'touchmove',
      function (e) {
        if (!e.touches || !e.touches[0]) return;
        deltaX = e.touches[0].clientX - startX;
      },
      { passive: true }
    );
    track.addEventListener(
      'touchend',
      function () {
        if (Math.abs(deltaX) > 40) {
          goTo(deltaX < 0 ? index + 1 : index - 1);
        }
        start();
      },
      { passive: true }
    );

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    goTo(0);
    start();
  }

  function boot() {
    document.querySelectorAll('[data-sg-testimonials]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    var root = event.target.querySelector('[data-sg-testimonials]');
    if (root) {
      root.dataset.sgTestimonialsReady = '';
      init(root);
    }
  });
})();
